import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { useCombobox } from 'downshift';
import DeleteButton from './DeleteButton';
export default function LanguageSelect({ allLanguages, setLanguage, languageId, label, identifier, }) {
    const [suggestions, setSuggestions] = useState([]);
    const [textInput, setTextInput] = useState('');
    useEffect(() => {
        // Set initial text input if URL contains languageId
        if (!languageId || textInput) {
            return;
        }
        const language = allLanguages.find(({ id }) => id === languageId);
        if (language) {
            setTextInput(language.label);
        }
    }, [languageId]);
    useEffect(() => {
        setSuggestions(getFilteredLanguages(textInput, allLanguages));
    }, [textInput, allLanguages]);
    const handleSelection = (selection) => {
        var _a;
        const languageId = (_a = selection === null || selection === void 0 ? void 0 : selection.selectedItem) === null || _a === void 0 ? void 0 : _a.id;
        setLanguage(languageId ? languageId : 0);
    };
    const { isOpen, getLabelProps, getMenuProps, highlightedIndex, getItemProps, getInputProps, getComboboxProps, openMenu, reset, } = useCombobox({
        items: suggestions,
        itemToString,
        onInputValueChange: (inputData) => { var _a; return setTextInput((_a = inputData.inputValue) !== null && _a !== void 0 ? _a : ''); },
        onSelectedItemChange: handleSelection,
    });
    useEffect(() => {
        if (!languageId) {
            reset();
        }
    }, [languageId, reset]);
    const deleteFunction = useCallback(() => {
        reset();
        setLanguage(0);
        setTextInput('');
    }, [setLanguage, reset]);
    const handleFocus = (isOpen) => {
        if (!isOpen && textInput && suggestions.length) {
            openMenu();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("label", Object.assign({}, getLabelProps(), { htmlFor: `language-input-${identifier}`, id: `downshift-${identifier}-label` }, { children: label }), void 0), _jsxs("div", Object.assign({ className: "combobox combobox--location" }, getComboboxProps(), { children: [_jsxs("div", Object.assign({ className: "input-delete-wrapper" }, { children: [_jsx("input", Object.assign({ className: "combobox__input" }, getInputProps({ onFocus: () => handleFocus(isOpen) }), { value: textInput, id: `language-input-${identifier}` }), void 0), _jsx(DeleteButton, { label: zankFinderStrings.clearInputLabel, deleteFunction: deleteFunction, descriptionId: `downshift-${identifier}-label`, hidden: textInput.length === 0 }, void 0)] }), void 0), _jsx("ul", Object.assign({ className: "combobox__list" }, getMenuProps(), { children: isOpen &&
                            suggestions.map((suggestion, index) => (_jsx("li", Object.assign({}, getItemProps({ item: suggestion, index }), { className: `combobox__item ${highlightedIndex === index
                                    ? 'combobox__item--highlighted'
                                    : ''}` }, { children: suggestion.label }), suggestion.id))) }), void 0)] }), void 0)] }, void 0));
}
function getFilteredLanguages(search, allLanguages) {
    const regEx = new RegExp(search, 'i');
    return allLanguages.filter(({ label }) => regEx.test(label));
}
function itemToString(item) {
    return (item === null || item === void 0 ? void 0 : item.label) ? item.label : '';
}
